<template lang="pug">
div
  .form-block-title {{t(`helpers.placeholder.form_block.label.${form_block.handle}`, {default: form_block.name})}}
  .panel-sections
    .panels.rows-3.select-spacer.clearfix(v-if="!noList && !registration.program.preview")
        .select
            span.selected
                span.value {{ selected_title }}
                span.caret
            select.for-panel-select(v-model="selected_id2" :disabled="!registration.person_id")
                option(:value="null") {{ first_choice }}
                option(
                    v-for="obj in objects"
                    :key="obj.id"
                    :value="obj.id",
                    :selected="obj.id === selected_id2"
                    :disabled="disabled(obj.id)"
                ) {{ obj.opt_title }}
                option(:value="-1") {{new_choice}}
    .panel-contents
      fp-content(:form_blocks="form_blocks", :old_rfb="rfb1" :entity_selected="noList")
</template>
<script>
import helpers from '../../../code/base_mixins'
import helper_relation_objects from '../form_block/relation_objects'
import FpContent from '../form_part/_content'
export default{
  components: {FpContent},
  mixins: [helpers,helper_relation_objects],
  props: ["form_block", "form_part"],
  computed: {
    registration(){ return this.state.current_reg },
    noList(){ return this.objects.length===0 },
    form_blocks(){
      if (this.form_part.has_many_block_styles()){
        return this.form_part.form_blocks
      }else{
        return this.form_block ? [this.form_block] : []
      }
    },
    rfb1(){
      return this.r_form_block()
    },
    rfbs(){
      // const main_rfb = this.r_form_block()
      // const fb_ids = []

      const rfbs   = []
      rfbs.push(this.rfb1)
      for (const fb  of this.form_part.form_blocks){
        if (fb.style.endsWith("PartParentAddress") || fb.style.endsWith("PartEmergencyContact") || fb.style.endsWith("PartDoctor")) continue;
        // fb_ids.push(fb.id)
        rfbs.push(this.r_form_block(fb))
      }
      // for (const rfb of this.registration.registration_form_blocks){
      //   // if ( fb_ids.indexOf(rfb.form_block_id) > -1 ){
      //   //   rfb.entity_attrs = main_rfb.entity_attrs
      //   //   rfb.entity_id    = main_rfb.entity_id
      //   // }
      //   // rfbs.push(rfb)
      // }
      return rfbs
    },
  },
  watch: {
    "registration.person_id"(){this.onChange()},
    "registration.loaded"(){   this.onChange()},
    "form_block.prefetch_new_element"(){
      switch(this.form_block.style){
        case "Product::FormBlock::PartParent":
          this.prefetchNew("reg_store/people_family")
          break
        case "Product::FormBlock::PartDoctor":
          this.prefetchNew("reg_store/people_doctors")
          break
        case "Product::FormBlock::PartEmergencyContact":
          this.prefetchNew("reg_store/people_emergencies")
          break
        case "Product::FormBlock::PartInsurance":
          this.prefetchNew("reg_store/people_insurances")
          break
      }
    },
  },
  created(){
    this.relation_objects()
  },
  methods: {
    async onChange(){
      // if this was new participant after save then do nothing
      if (this.registration.new_person_was) return

      await this.relation_objects()
      // this.afterSelectedChange()
    },
    // afterSelectedChange(){
    //   const main_rfb = this.r_form_block()
    //   let fb_ids     = []
    //   for (const fb  of this.form_part.form_blocks){
    //     if (fb.style.endsWith("PartParentAddress") || fb.style.endsWith("PartEmergencyContact") || fb.style.endsWith("PartDoctor")) continue;
    //     fb_ids.push(fb.id)
    //   }
    //   // for (const rfb of this.registration.registration_form_blocks){
    //   //   if ( fb_ids.indexOf(rfb.form_block_id) > -1 ){
    //   //     rfb.entity_attrs = main_rfb.entity_attrs
    //   //     rfb.entity_id    = main_rfb.entity_id
    //   //   }
    //   // }
    // },
    disabled(obj_id){
      return this.form_block.form_part.style === 'Parent' && obj_id === this.registration.person_id
    }
  }
}
</script>
